import * as React from "react";
const SvgTrendingUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 8"
    {...props}
  >
    <path
      fill="none"
      stroke={props.fill || "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1 6.5L4.5 3L7 5.5L11 1"
    />
    <path
      fill="none"
      stroke={props.fill || "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 1H11V4"
    />
  </svg>
);
export default SvgTrendingUp;
